export const ageMethod = "age nearest";
export const gateway = "https://qat-atlasyork-api.link-nonprod.wawanesalife.com";
export const assets = "https://qat-assets.link-nonprod.wawanesalife.com/brokers/atlasyork";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJhdGxhc3lvcmsiLCJuYW1lIjoiYXRsYXN5b3JrIiwiaWF0IjoxNzgwNTgyMDMxLCJleHAiOjE5MzgzNzAwMzF9.zREyqOjsQjKr-RiUSjI12wj6bmtGG6oDhEyXkyI5js4";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"qat-atlasyork-shopper.link-nonprod.wawanesalife.com": {
		a: {
			approve_company: "Link Platform",
			approve_user: "link_atlasyork",
			brands: [
				"qat-atlasyork-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "atlasyork",
			broker_formatted_name: "Atlas York Insurance",
			email: "service@atlasyork.ca",
			environment: "qat",
			environment_id: "qat",
			layout: "flat",
			logoPosition: "menu",
			"maps": {
				"map4": [
					"111 2nd Ave",
					"Dodsland",
					"SK",
					"S0L 0V0",
				],
				"map3": [
					"204 Main Street",
					"Coleville",
					"SK",
					"S0L 0K0",
				],
				"map2": [
					"219 Main Street",
					"Rosetown",
					"SK",
					"S0L 2V0",
				],
				"map1": [
					"3550 Taylor Street",
					"Saskatoon",
					"SK",
					"S7H 5H9",
				],
			},
			menuPhone: "button",
			phone: "306.986.0600",
			privacyLink: "https://atlasyork.ca/privacy-policy/",
			website: "https://atlasyork.ca/",
			scope: "atlasyork#branding#qat-atlasyork-shopper.link-nonprod.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "qat-atlasyork-shopper.link-nonprod.wawanesalife.com",
		},
		b: {
			approve_company: "Link Platform",
			approve_user: "link_atlasyork",
			brands: [
				"qat-atlasyork-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "atlasyork",
			broker_formatted_name: "Atlas York Insurance",
			email: "service@atlasyork.ca",
			environment: "qat",
			environment_id: "qat",
			layout: "flat",
			logoPosition: "menu",
			"maps": {
				"map4": [
					"111 2nd Ave",
					"Dodsland",
					"SK",
					"S0L 0V0",
				],
				"map3": [
					"204 Main Street",
					"Coleville",
					"SK",
					"S0L 0K0",
				],
				"map2": [
					"219 Main Street",
					"Rosetown",
					"SK",
					"S0L 2V0",
				],
				"map1": [
					"3550 Taylor Street",
					"Saskatoon",
					"SK",
					"S7H 5H9",
				],
			},
			menuPhone: "button",
			phone: "306.986.0600",
			privacyLink: "https://atlasyork.ca/privacy-policy/",
			website: "https://atlasyork.ca/",
			scope: "atlasyork#branding#qat-atlasyork-shopper.link-nonprod.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "qat-atlasyork-shopper.link-nonprod.wawanesalife.com",
		},
	},
};

//updated on Thu Jun 04 2026 14:07:11 GMT+0000 (Coordinated Universal Time)
